module.exports = __webpack_public_path__ + "img/truefinish.592867e3.png";